import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule, PageComponentModule } from '@spartacus/storefront';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { KbMyTicketsComponent } from './kb-my-tickets/kb-my-tickets.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { KbcreatenewTicketComponent } from './kbcreatenew-ticket/kbcreatenew-ticket.component';
import { KbTicketsTableViewComponent } from './kb-tickets-table-view/kb-tickets-table-view.component';
import { UpdateMyTicketsComponent } from './update-my-tickets/update-my-tickets.component';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { TicketEditComponent } from './update-my-tickets/ticket-edit/ticket-edit.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../../kb-pagination/kb-pagination/kb-pagination.module';


@NgModule({
    declarations: [KbMyTicketsComponent, KbcreatenewTicketComponent, KbTicketsTableViewComponent, UpdateMyTicketsComponent, TicketEditComponent],
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        IconModule,
        I18nModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MediaModule,
        FormsModule,
        BsDatepickerModule,
        KbMyAccountLeftSideNavModule,
        KbPaginationModule,
        PageComponentModule,
        ReactiveFormsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                MyTicketFlexComponent: {
                    component: KbMyTicketsComponent,
                    guards: [SecureGuard, AuthGuard]
                },
                MyTicketAddFlexComponent: {
                    component: KbcreatenewTicketComponent,
                    guards: [SecureGuard, AuthGuard]
                },
                //update-support-ticket
                MyTicketUpdateFlexComponent: {
                    component: UpdateMyTicketsComponent,
                    guards: [SecureGuard, AuthGuard]
                }
            }
        } as CmsConfig)
    ],
})
export class KbMyTicketsModule { }
